<template>
    <ui-modal-message-v-2
        :name='name'
        :cancel-button="true"
        :color-square="'primary'"
        icon-square
        :dynamic-icon="'ui-funnil'"
        :width-dynamic-icon="24"
        :height-dynamic-icon="16"
        @close-modal="handleCloseModal"
    >
        <template #title>
            <div class="header-container">
                <span class="first-title">Alteração de Responsável</span>
                <span class="second-title">
                    Escolha um responsável para{{ deals.length > 1 ? ' os ' : ' o ' }}
                    <span class="second-title-weight">
                        {{ deals.length > 1 ? deals.length : "" }} {{deals.length > 1 ? 'negócios ' : 'negócio '}}
                    </span>
                    {{deals.length > 1 ? 'selecionados.' : 'selecionado.'}}       
                </span>
            </div>

            <div class="diviser"/>
        </template>
        <template #text>
            <div v-if="loadingConfigs" class="loader">
                <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="30" :stroke="8" />
            </div>
            <div v-else class="text-container">
                <div class="selects-container">
                    <uiSearchUser 
                        v-model="searchTerm"
                        container-height="251px"
                        :loading="loading"
                        search-message="Buscar Usuário por Nome ou Equipe"
                    >
                        <template #sourceList>
                            <perfect-scrollbar
                                class="card-container scroll-container"
                                @scroll.native="onScroll"
                            >
                                <div>    
                                    <div v-if="users.length === 0 && !loading" class="empty-message">
                                        Nenhum usuário encontrado.
                                    </div>
                                    <div
                                        v-for="user in users"
                                        :key="user.id"
                                        @click="onSelectUser(user)"
                                    >
                                        <ui-responsible-card
                                            :user="user"
                                            :is-selected="selectedUsers.some(u => u.id === user.id)"
                                            :is-disabled="selectedUsers.length > 0 && selectedUsers[0].id !== user.id"
                                        />
                                    </div>
                                </div>
                            </perfect-scrollbar>
                        </template>
                    </uiSearchUser>
                </div>

                    
                <div
                    v-if="shouldShowSwitch"
                    class="switch-container"
                >
                    <ui-switch
                        
                        v-model="changeResponsibleCustomer"
                        :checked="changeResponsibleCustomer"
                        design="xs primary"
                        class="switch"
                    />
                    Alterar também os responsáveis do cliente.
                </div>

                <div class="diviser"/>
            </div>


            <uiCodeConfirm 
                ref="codeConfirmRef"
                :code-name="name"
                :is-warning-text="false"
                @code-validated="handleCodeValidation"
            />
           
        </template>
        <template #footer>
            <ui-button
                :design="'md success'"
                :disabled="!isFormValid"
                @click="onSubmit"
            >
                Alterar Responsabilidade
            </ui-button>
        </template>
    </ui-modal-message-v-2>
</template>

<script>
import { uiModalMessageV2 } from '@/components/ui/modal'
import { uiButton } from '@/components/ui/buttons'
import { funnel, configuration } from '@/services/axios'
import { uiCodeConfirm, uiLoadIndicator, uiSearchUser } from '@/components/ui'
import uiResponsibleCard from './ui-responsible-card'
import { uiSwitch } from '@/components/ui/form'
import {
   permissionsMixin,
} from '@/mixins'

export default {
  name: 'change-responsible-modal-bulk',

  components: {
    uiModalMessageV2,
    uiButton,
    uiCodeConfirm,
    uiSearchUser,
    uiResponsibleCard ,
    uiSwitch,
    uiLoadIndicator
  },
  mixins: [permissionsMixin],

  props: {
    name: {
      type: String,
      default: 'change-responsible-modal-bulk'
    },
    deals: {
        type: Array,
        required: true
    },
    closeModalAction: {
      type: Function,
      default: null
    },
  },

  data() {
    return {
        allStages: [],
        selectedStageId: null,
        selectedStageStatusId: null,
        isCodeValid: false,
        isBulkAction: false,
        selectedUsers:[],
        loading:  false,
        // chamada paginação
        users: [],
        currentPage: 1,
        perPage: 15,
        hasMoreUsers: true,
        //busca
        searchTerm: '',
        debouncedSearch: '',
        searchDebounceTimeout: null,
        isShowSwitch: true,
        changeResponsibleCustomer:false,
        changeResponsible: {},
        loadingConfigs: false
    }
  },

  computed: {
        isFormValid() {
            
            return (
                !this.loading &&
                this.isCodeValid &&
                this.selectedUsers.length > 0
            );
        },
        shouldShowSwitch() {
            return (
                this.changeResponsible.changeResponsible === 'ask' ||
                (this.$mx_userIsAdminOrCollaborator &&
                    this.changeResponsible.changeResponsible === 'onlyAdminAsk')
            )
        }
    },
    watch: {
      searchTerm(newVal) {
        this.selectedUsers = [];
        clearTimeout(this.searchDebounceTimeout);

        this.searchDebounceTimeout = setTimeout(() => {
          this.debouncedSearch = newVal;
          this.resetPagination();
          this.getAllUsers();
        }, 500); 
      }
    },

    mounted() {
        this.$root.$on(`modal-msg-open-${this.name}`, () => {
            this.resetPagination();
            this.getAllUsers();
            this.loadChangeResponsibleConfig()
        })
    },

    beforeDestroy() {
        this.$root.$off(`modal-msg-open-${this.name}`, () => {
            this.resetPagination();
            this.getAllUsers();
        })
    },

    methods: {
        async getAllUsers() {
            if (this.loading || !this.hasMoreUsers) return;

            this.loading = true;

            funnel.getAllUsers({
                perPage: this.perPage,
                page: this.currentPage,
                search: this.translateGroupToEnglish(this.debouncedSearch)
            })
            .then((response) => {
                const rawUsers = response?.data?.data?.data || [];
            
                const formattedUsers = rawUsers.map(user => ({
                    id: user.id,
                    name: user?.first_name,
                    group: this.renderGroups(user?.groups[0]?.name || ''),
                    photo: user?.photo || user?.cover,
                    count: user?.count
                }));
            
                const pagination = response?.data?.data;
            
                this.users = [...this.users, ...formattedUsers];
            
                if (pagination.current_page >= pagination.lastPage) {
                    this.hasMoreUsers = false;
                } else {
                    this.currentPage++;
                }
            })
            .catch((error) => {
                if (error.data && error.data.msg) {
                    this.$toastr.e(error.data.msg);
                }
            })
            .finally(() => {
                this.loading = false;
            });

        },

        // Função para montar os nomes dos grupos dos usuários
        renderGroups(groupName) {
            const groupStrategies = {
            manager: 'Gerente',
            collaborator: 'Colaborador',
            admin: 'Administrador',
            broker: 'Corretor',
            supervisor: 'Supervisor',
            };

            return groupStrategies[groupName] || groupName
        },

        handleCloseModal() {
        if (this.closeModalAction) this.closeModalAction()

            this.resetPagination()
            this.isCodeValid = false
            this.searchTerm = '';
            this.selectedUsers = [];  
            this.changeResponsibleCustomer = false

            this.$nextTick(() => {
                this.$refs.codeConfirmRef?.resetCode()
            })
        },

        onSubmit() {
            this.isBulkAction = true            

            const responsible = this.selectedUsers[0]

            const config = this.changeResponsible.changeResponsible
            let changeResponsibleCustomer = false
                
            if (config === 'onlyAdmin') {
                changeResponsibleCustomer = this.$mx_userIsAdminOrCollaborator
            } else if (config === 'all') {
                changeResponsibleCustomer = true
            } else if (config === 'ask' || config === 'onlyAdminAsk') {
                changeResponsibleCustomer = this.changeResponsibleCustomer
            }

            this.$emit('bulk-step-data', {
                responsible: {
                    id: responsible.id,
                    name: responsible.name,
                    team_name: responsible?.group
                },
                changeResponsibleCustomer
            })

            this.$root.$emit(`modal-msg-close-${this.name}`)
        },
        onSelectUser(user) {
          if (this.selectedUsers.length && this.selectedUsers[0].id === user.id) {
            this.selectedUsers = []
          } else {
            this.selectedUsers = [user]
          }
        },
        handleCodeValidation({ name, isValid }) {
            if (name === this.name) {
                this.isCodeValid = isValid;
            }
        },

        onScroll(e) {
            const bottomReached = e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 10;
            if (bottomReached) {
                this.getAllUsers();
            }
        },
        resetPagination() {
            this.users = [];
            this.currentPage = 1;
            this.hasMoreUsers = true;
        },

        translateGroupToEnglish(term) {
          const normalizedTerm = term
            .trim()
            .normalize("NFD")             // remove acentos
            .replace(/[\u0300-\u036f]/g, "") // remove diacríticos
            .toLowerCase();              // deixa tudo minúsculo

          const groupTranslations = {
            gerente: 'manager',
            colaborador: 'collaborator',
            administrador: 'admin',
            corretor: 'broker',
            supervisor: 'supervisor',
          };
      
          return groupTranslations[normalizedTerm] || term;
        },

        async loadChangeResponsibleConfig() {
            this.loadingConfigs = true
            configuration.getConfigurations()
            .then((response) => {
                const config = response?.data || {};

                for (const key in config) {
                    if (config[key].name === 'customerDuplicate' && config[key].value_long) {
                        this.changeResponsible = config[key].value_long;
                    }
                }
            })
            .catch((error) => {
                if (error.data && error.data.msg) {
                    this.$toastr.e(error.data.msg);
                }
            })
            .finally(() => {
                this.loadingConfigs = false;
            });
        }

    }

}
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>